var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_289_492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 35.75C21.12 35.75 17.15 31.78 17.15 26.9C17.12 21.17 22.58 16.4 24.93 14.61C25.56 14.13 26.44 14.13 27.07 14.61C29.42 16.43 34.88 21.26 34.85 26.91C34.85 31.78 30.88 35.75 26 35.75ZM26 15.75C25.95 15.75 25.89 15.77 25.84 15.81C24.15 17.1 18.63 21.71 18.66 26.9C18.66 30.96 21.96 34.25 26.01 34.25C30.06 34.25 33.36 30.96 33.36 26.91C33.39 21.79 27.86 17.12 26.16 15.81C26.1 15.77 26.05 15.75 26 15.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 35.75C25.59 35.75 25.25 35.41 25.25 35V15C25.25 14.59 25.59 14.25 26 14.25C26.41 14.25 26.75 14.59 26.75 15V35C26.75 35.41 26.41 35.75 26 35.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 32.7102C25.7199 32.7102 25.4499 32.5502 25.3199 32.2902C25.1399 31.9202 25.2899 31.4702 25.6699 31.2902L33.3699 27.5502C33.7399 27.3702 34.1899 27.5302 34.3699 27.9002C34.5499 28.2702 34.4 28.7202 34.02 28.9002L26.3199 32.6402C26.2199 32.6802 26.1099 32.7102 25.9999 32.7102Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 27.7101C25.7199 27.7101 25.4499 27.5501 25.3199 27.2901C25.1399 26.9201 25.2899 26.4701 25.6699 26.2901L33.0399 22.7101C33.4099 22.5301 33.8599 22.6801 34.0399 23.0601C34.2199 23.4401 34.0699 23.8801 33.6899 24.0601L26.3199 27.6401C26.2199 27.6801 26.1099 27.7101 25.9999 27.7101Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 22.71C25.7199 22.71 25.4499 22.55 25.3199 22.29C25.1399 21.92 25.2899 21.47 25.6699 21.29L30.7 18.85C31.07 18.67 31.52 18.83 31.7 19.2C31.88 19.57 31.7299 20.02 31.3499 20.2L26.3199 22.64C26.2199 22.68 26.1099 22.71 25.9999 22.71Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_289_492",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_289_492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_289_492",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeans);
export default __webpack_public_path__ + "static/media/means.f36013c438d485cda4c3a67244fe4847.svg";
export { ForwardRef as ReactComponent };